var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.637 6.48797C14.3197 6.17067 13.8053 6.17067 13.488 6.48797L8.47656 11.4987L6.51202 9.53485L6.43548 9.46726C6.11674 9.21942 5.65587 9.24195 5.36297 9.53485C5.04567 9.85215 5.04567 10.3666 5.36297 10.6839L7.90203 13.223L7.97858 13.2905C8.29731 13.5384 8.75819 13.5159 9.05108 13.223L14.637 7.63702L14.7046 7.56048C14.9524 7.24174 14.9299 6.78086 14.637 6.48797Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle-tick.007f4b46a9c81a5d63e692827f69b3b3.svg";
export { ForwardRef as ReactComponent };